<template>
  <router-link
    v-if="mobile"
    :class="{ arrow: true, 'hidden-sm-and-up': true, selected: selected }"
    :to="`/products/${productCategory.slug}#products`"
    @mouseover.native="hover = true"
    @mouseleave.native="hover = false"
    :style="{
      backgroundImage:
        (selected ? linearGradient : overlay) +
        categoryBackgroundImage,
    }"
  >
    {{ productCategory.title }}
    {{ selected ? 'ACTIVE' : 'NOT' }}
  </router-link>
  <router-link
    v-else
    :class="{ arrow: true, 'hidden-xs-only': true, selected: selected }"
    :to="`/products/${productCategory.slug}`"
    @mouseover.native="hover = true"
    @mouseleave.native="hover = false"
    :style="{
      backgroundImage:
        (selected ? linearGradient : overlay) +
        categoryBackgroundImage,
    }"
  >
    {{ productCategory.title }}
  </router-link>
</template>

<script>
const linearGradientString =
  'linear-gradient(180deg, rgba(179, 0, 11, 0.55) 0%, #CC000D 100%), ';

export default {
  name: 'ProductCategoryLink',
  props: ['productCategory', 'selected', 'mobile'],
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    categoryBackgroundImage() {
      const imageUrl =
        this.productCategory &&
        this.productCategory.mainImage &&
        this.productCategory.mainImage[0] &&
        this.productCategory.mainImage[0].url;
      return imageUrl ? `url(${imageUrl})` : 'none';
    },
    overlay() {
      if (this.hover) {
        return linearGradientString;
      } else {
        return '';
      }
    },
    linearGradient() {
      return linearGradientString;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

a {
  display: block;
  flex-basis: 20%;
  color: $--color-white;
  padding: 150px 20px 30px 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: $--color-secondary;
  font-size: 16px;

  &:after {
    background-color: $--color-white;
    margin-left: 0.25rem;
  }

  @include res(sm-only, $--breakpoints-spec) {
    text-align: center;
    padding-top: 125px;

    &:after {
      display: none;
    }
  }

  @include res(xs-only, $--breakpoints-spec) {
    text-align: left;
    padding-top: 20px;
    padding-bottom: 20px;
    background-image: none !important;

    &:after {
      display: inline-block;
    }
  }
}

a:hover {
  cursor: pointer;

  @include res(xs-only, $--breakpoints-spec) {
    background-image: linear-gradient(
      180deg,
      rgba(179, 0, 11, 0.55) 0%,
      #cc000d 100%
    ) !important;
  }

  &:after {
    background-color: $--color-white;
  }
}

a:focus {
  &:after {
    background-color: $--color-white;
  }
}

.selected {
  @include res(xs-only, $--breakpoints-spec) {
    background-image: linear-gradient(
      180deg,
      rgba(179, 0, 11, 0.55) 0%,
      #cc000d 100%
    ) !important;
  }
}
</style>
